<template>
  <div class="page">
    <list
      title="Veículos"
      tag="vehicles"
      subtitle="Nesta tela você cria e verifica os templates de consultas de veículos."
      :create-route="{ name: 'Template-Vehicle-Create' }"
    />
  </div>
</template>

<script>
import List from '@/template/components/List.vue';

export default {
  name: 'Index',

  components: {
    List,
  },
};
</script>

<style scoped>

</style>
